import { FC } from 'react';

import SwitchField from '@payaca/components/switchField/SwitchField';

import EntityCard from '@payaca/components/entityCard/EntityCard';
import {
  AutomationActionTypes,
  PublicHydratedDefaultAutomationDefinition,
} from '@payaca/types/automationTypes';
import './DefaultAutomationCard.sass';

type Props = {
  defaultAutomationDefinition: Pick<
    PublicHydratedDefaultAutomationDefinition<AutomationActionTypes>,
    'title' | 'automation'
  >;
  onClick?: () => void;
};

const DefaultAutomationCard: FC<Props> = ({
  defaultAutomationDefinition,
  onClick,
}) => {
  const { automation, ...automationDefinition } = defaultAutomationDefinition;
  return (
    <EntityCard className="default-automation-card" onClick={onClick}>
      <span className="title">{automationDefinition.title}</span>
      <SwitchField name="-" value={automation?.isActive} />
    </EntityCard>
  );
};

export default DefaultAutomationCard;
